// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-timeline{display:block;max-width:634px;padding-top:40px}@media (min-width:768px){.h-timeline{padding-top:64px}}", ""]);
// Exports
module.exports = exports;
